import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
const BASE_FORM_URL = process.env.MONDAY_EMBEDDED_FORM_BASE_PATH;
const FORM_IFRAME = "formIframe";
const EmbeddedFormComponent = (props)=>{
    const _iframe = useRef(null);
    const { columnsMappingFromParams = [], formToken, width, height, boxShadow, marginTop, marginLeft, position, borderRadius, paddingTop } = props;
    const getUrlParameter = (name)=>{
        const parsedName = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        const regex = new RegExp(`[\\?&]${parsedName}=([^&#]*)`);
        const results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    };
    const appendQueryParamByColumnId = (queryParams, column)=>{
        const { columnId, columnParamName } = column;
        queryParams[columnId] = getUrlParameter(columnParamName);
        return queryParams;
    };
    const addDataFromParameter = (data)=>{
        return columnsMappingFromParams.reduce(appendQueryParamByColumnId, data);
    };
    const sendPlaceholderAndSource = ()=>{
        var _iframe_current_contentWindow, _iframe_current;
        _iframe === null || _iframe === void 0 ? void 0 : (_iframe_current = _iframe.current) === null || _iframe_current === void 0 ? void 0 : (_iframe_current_contentWindow = _iframe_current.contentWindow) === null || _iframe_current_contentWindow === void 0 ? void 0 : _iframe_current_contentWindow.postMessage({
            formIframe: FORM_IFRAME,
            formData: addDataFromParameter({})
        }, "*");
    };
    const formURL = `${BASE_FORM_URL}/${formToken}`;
    return /*#__PURE__*/ _jsx("div", {
        className: "embedded-form-component",
        children: /*#__PURE__*/ _jsx("iframe", {
            ref: _iframe,
            src: formURL,
            style: {
                width,
                height,
                boxShadow,
                marginTop,
                marginLeft,
                position,
                borderRadius,
                paddingTop
            },
            frameBorder: "0",
            onLoad: sendPlaceholderAndSource
        })
    });
};
export default EmbeddedFormComponent;
